import { api } from "@api/api";
import { appendFormData } from "@core/utils/appendFormData";
import { Module } from "@modules/agreements/types/module";
import { ModuleFormValues } from "@modules/agreements/validations/moduleSchema";

export async function editModuleService(id: string, data: Partial<ModuleFormValues>): Promise<Module> {
  const payload = appendFormData({
    ...data,
    icon: typeof data.icon === "string" ? null : data.icon,
  });

  const { data: module } = await api.patch<Module>(`v1/agreement_modules_admin/${id}/`, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return module;
}
